import { useEffect, useState } from 'react';
import { useDashboardStorage } from '@hooks/useDashboardStorage';
export const useLaunchStrategyProgress = () => {
    const { dashboardStorage } = useDashboardStorage();
    const initialActiveCategoryIndex = dashboardStorage.get('launchStrategy.category') || 0;
    const initialActiveGuideIndex = dashboardStorage.get('launchStrategy.guide') || 0;
    const [activeCategoryIndex, setActiveCategoryIndex] = useState(initialActiveCategoryIndex);
    const [activeGuideIndex, setActiveGuideIndex] = useState(initialActiveGuideIndex);
    useEffect(() => {
        dashboardStorage.set('launchStrategy.category', activeCategoryIndex);
        dashboardStorage.set('launchStrategy.guide', activeGuideIndex);
    }, [activeCategoryIndex, activeGuideIndex, dashboardStorage]);
    return {
        category: {
            index: activeCategoryIndex,
            setIndex: setActiveCategoryIndex,
        },
        guide: {
            index: activeGuideIndex,
            setIndex: setActiveGuideIndex,
        },
    };
};
